export default __webpack_public_path__ + "static/media/reg-n-get.3686324f.svg";